module.exports = "./assets/images/avatar-6.svg";